import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../..//shared/services/communication.service';
import { ApiService } from './../..//shared/services/api.service';
import { ListBase } from './../..//shared/components/base/list/list.base.component';
import { DeveloperProject } from './../..//models/real-estates/real-estates.model';

@Component({
  selector: 'swb-developer-projects-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class DeveloperProjectsListComponent extends ListBase<DeveloperProject> implements OnInit {

  public url = 'developer-projects';
  public routePrefix = 'developer-projects';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
